import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import SaveChanges from "../client_config/SaveChanges";

export default function ProgressBar({
  submitForm,
  percent,
  setPercent,
  onboardingProgress,
  onboardingComplete,
  setOnboardingComplete,
  manualDataPull,
}) {
  let leftBar = require("images/onboarding/left-bar.png");
  leftBar = <img src={`/datapulse${leftBar}`} />;
  let midBar = require("images/onboarding/mid-bar.png");
  midBar = <img src={`/datapulse${midBar}`} />;
  let rightBar = require("images/onboarding/right-bar.png");
  rightBar = <img className="right-bar" src={`/datapulse${rightBar}`} />;

  const [allComplete, setAllComplete] = useState(false);
  //In below lines for state we are checking if useState([Is section completed? , Is section in progress?])
  const [generalComplete, setGeneralComplete] = useState([false, false]);
  const [teamAccessComplete, setTeamAccessComplete] = useState([false, false]);
  const [serviceComplete, setServiceComplete] = useState([false, false]);
  const [ppcConfigComplete, setPpcConfigComplete] = useState([false, false]);
  const [seoConfigComplete, setSeoConfigComplete] = useState([false, false]);

  let generalUrls = onboardingProgress.filter((item) => item.section === "general").map((el) => el.url);
  let teamUrls = onboardingProgress.filter((item) => item.section === "team").map((el) => el.url);
  let serviceUrls = onboardingProgress.filter((item) => item.section === "service").map((el) => el.url);
  let ppcUrls = onboardingProgress.filter((item) => item.section === "ppc").map((el) => el.url);
  let seoUrls = onboardingProgress.filter((item) => item.section === "seo").map((el) => el.url);
  const [serviceArray, setServiceArray] = useState([]);
  const [seoArray, setSeoArray] = useState([]);
  const [ppcArray, setPpcArray] = useState([]);
  let generalArray = [];
  let teamArray = [];

  const isUndefined = (value) => value === undefined;



  useEffect(() => {
    let tempGeneralArray = [];
    let tempTeamArray = [];
    let tempServiceArray = [];
    let tempPpcArray = [];
    let tempSeoArray = [];

    for (let i = 0; i < onboardingProgress.length; i++) {
      if (i <= 8) {
        generalArray.push(onboardingProgress[i].completed);
        //we are checking if the onboarding item is completed and required.  If we see completed === true and required === false, we know this item was skipped
        //and our map below does not look for this condition so it will return undefined so this particular value will not be included in evaluating the section progress.
        // setGeneralArray(tempGeneralArray)
      }
      if (i >= 9 && i <= 20) {
        teamArray.push(onboardingProgress[i].completed);
      }
      if (i >= 21 && i <= 23) {
        tempServiceArray.push([onboardingProgress[i].completed, onboardingProgress[i].required]);
        let temp = tempServiceArray.map((el) => {
          if (el[0] === false && el[1] === true) {
            return false;
          }
          if (el[0] === true && el[1] === true) {
            return true;
          }
        });
        setServiceArray(temp);
      }
      if (i >= 24 && i <= 39) {
        tempPpcArray.push([onboardingProgress[i].completed, onboardingProgress[i].required]);
        let temp = tempPpcArray.map((el) => {
          if (el[0] === false && el[1] === true) {
            return false;
          }
          if (el[0] === true && el[1] === true) {
            return true;
          }
        });
        setPpcArray(temp);
      }
      if (i >= 40 && i <= 48) {
        tempSeoArray.push([onboardingProgress[i].completed, onboardingProgress[i].required]);
        let temp = tempSeoArray.map((el) => {
          if (el[0] === false && el[1] === true) {
            return false;
          }
          if (el[0] === true && el[1] === true) {
            return true;
          }
        });
        setSeoArray(temp);
      }
      if (!generalArray.includes(false)) {
        setGeneralComplete([true, false]);
      }
      if (generalArray.includes(false) && generalArray.includes(true)) {
        setGeneralComplete([false, true]);
      }
      if (!generalArray.includes(true)) {
        setGeneralComplete([false, false]);
      }
      if (!teamArray.includes(false)) {
        setTeamAccessComplete([true, false]);
      }
      if (teamArray.includes(false) && teamArray.includes(true)) {
        setTeamAccessComplete([false, true]);
      }
      if (!teamArray.includes(true)) {
        setTeamAccessComplete([false, false]);
      }
      if (!serviceArray.includes(false)) {
        setServiceComplete([true, false]);
      }
      if (serviceArray.includes(false) && serviceArray.includes(true)) {
        setServiceComplete([false, true]);
      }
      if (!serviceArray.includes(true)) {
        setServiceComplete([false, false]);
      }
      if (!ppcArray.includes(false)) {
        setPpcConfigComplete([true, false]);
      }
      if (ppcArray.includes(false) && ppcArray.includes(true)) {
        setPpcConfigComplete([false, true]);
      }
      if (!ppcArray.includes(true)) {
        setPpcConfigComplete([false, false]);
      }
      if (!seoArray.includes(false)) {
        setSeoConfigComplete([true, false]);
      }
      if (seoArray.includes(false) && seoArray.includes(true)) {
        setSeoConfigComplete([false, true]);
      }
      if (!seoArray.includes(true)) {
        setSeoConfigComplete([false, false]);
      }
      if (
        generalComplete[0] === true &&
        teamAccessComplete[0] === true &&
        serviceComplete[0] === true &&
        (ppcConfigComplete[0] === true || ppcArray.every(isUndefined)) &&
        (seoConfigComplete[0] === true || seoArray.every(isUndefined)) === true
      ) {
        setAllComplete((prev) => true);
      } else {
        setAllComplete((prev) => false);
      }
    }
  }, [onboardingProgress, generalComplete[0], teamAccessComplete[0], serviceComplete[0], ppcConfigComplete[0], seoConfigComplete[0]]);

  useEffect(() => {
    if (allComplete === true) {
      setOnboardingComplete((prev) => true);
    }
  }, [allComplete, generalComplete[0], teamAccessComplete[0], serviceComplete[0], ppcConfigComplete[0], seoConfigComplete[0]]);
  return (
    <Container className="ob-button progress-bar-container" fluid>
      <Row className="justify-content-between">
        <Col xs={12} sm={true}>
          <SaveChanges
            onboarding
            onClick={() => {
              if (window.location.pathname == "/datapulse/onboarding/ppc_data_pull" || "/datapulse/onboarding/seo_data_pull") manualDataPull();
              submitForm(window.location.pathname);
            }}
          />
        </Col>
        <Col className="mt-1">
          <div className="progress-wrapper">
            <div className=" progress-bar">
              <div className="filler" style={{ width: `${percent.percent()}%` }}></div>
              <span className="percentage f-12">
                <strong style={onboardingComplete ? { color: "white" } : undefined}>{percent.percent()}%</strong>
              </span>
            </div>
            <div className="under-bar mt-3">
              <Row className="progress-overlay ">
                <Col className="p-0 mr-3">
                  <Link to="/datapulse/onboarding/account_configuration_intro">
                    <div
                      style={
                        //currently in progress
                        generalComplete[0] === false && generalUrls.includes(window.location.pathname)
                          ? { backgroundColor: "#3291c1" }
                          : //outstanding items remaining
                          generalComplete[0] === false && generalComplete[1] === true && !generalUrls.includes(window.location.pathname)
                            ? { backgroundColor: "#D97358" }
                            : //completed
                            generalComplete[0] === true
                              ? { backgroundColor: "#42ba96" }
                              : //not yet started
                              { backgroundColor: "#A3A3A3" }
                      }
                      onClick={() => setPercent((prevState) => ({ ...prevState, currentPage: 0 }))}
                      className="bar-box">
                      General Info
                    </div>
                  </Link>
                </Col>
                <Col className="p-0 mr-3">
                  <Link to="/datapulse/onboarding/team_access_intro">
                    <div
                      style={
                        //currently in progress
                        teamAccessComplete[0] === false && teamUrls.includes(window.location.pathname)
                          ? { backgroundColor: "#3291c1" }
                          : //outstanding items remaining
                          teamAccessComplete[0] === false && teamAccessComplete[1] === true && !teamUrls.includes(window.location.pathname)
                            ? { backgroundColor: "#D97358" }
                            : //completed
                            teamAccessComplete[0] === true
                              ? { backgroundColor: "#42ba96" }
                              : //not yet started
                              { backgroundColor: "#A3A3A3" }
                      }
                      className="bar-box">
                      Team Access
                    </div>
                  </Link>
                </Col>
                <Col className="p-0 mr-3">
                  <Link to="/datapulse/onboarding/service_agreements_intro">
                    <div
                      style={
                        //currently in progress
                        serviceComplete[0] === false && serviceUrls.includes(window.location.pathname)
                          ? { backgroundColor: "#3291c1" }
                          : //outstanding items remaining
                          serviceComplete[0] === false && serviceComplete[1] === true && !serviceUrls.includes(window.location.pathname)
                            ? { backgroundColor: "#D97358" }
                            : //completed
                            serviceComplete[0] === true
                              ? { backgroundColor: "#42ba96" }
                              : //not yet started
                              { backgroundColor: "#A3A3A3" }
                      }
                      className="bar-box">
                      Service Agreements
                    </div>
                  </Link>
                </Col>
                <Col className={ppcArray.every(isUndefined) && ppcArray.length > 0 ? "disabled " : undefined}>
                  <Link
                    to="/datapulse/onboarding/ppc_configuration_intro"
                    onClick={ppcArray.every(isUndefined) ? (event) => event.preventDefault() : undefined}>
                    <div
                      style={
                        //handle initial color
                        ppcArray.length === 0
                          ? { backgroundColor: "#A3A3A3" }
                          : //disabled
                          ppcArray.every(isUndefined)
                            ? { backgroundColor: "#CACACA", color: "#EEEEEE", cursor: "default" }
                            : //currently in progress
                            ppcConfigComplete[0] === false && ppcUrls.includes(window.location.pathname)
                              ? { backgroundColor: "#3291c1" }
                              : //outstanding items remaining
                              ppcConfigComplete[0] === false && ppcConfigComplete[1] === true && !ppcUrls.includes(window.location.pathname)
                                ? { backgroundColor: "#D97358" }
                                : //completed
                                ppcConfigComplete[0] === true
                                  ? { backgroundColor: "#42ba96" }
                                  : //not yet started
                                  { backgroundColor: "#A3A3A3" }
                      }
                      className="bar-box">
                      PPC Configuration
                    </div>
                  </Link>
                </Col>
                <Col className={seoArray.every(isUndefined) && seoArray.length > 0 ? "disabled" : undefined}>
                  <Link
                    to="/datapulse/onboarding/seo_configuration_intro"
                    onClick={seoArray.every(isUndefined) ? (event) => event.preventDefault() : undefined}>
                    <div
                      style={
                        //handle initial color
                        seoArray.length === 0
                          ? { backgroundColor: "#A3A3A3" }
                          : //disabled
                          seoArray.every(isUndefined)
                            ? { backgroundColor: "#CACACA", color: "#EEEEEE", cursor: "default" }
                            : //currently in progress
                            seoConfigComplete[0] === false && seoUrls.includes(window.location.pathname)
                              ? { backgroundColor: "#3291c1" }
                              : //outstanding items remaining
                              seoConfigComplete[0] === false && seoConfigComplete[1] === true && !seoUrls.includes(window.location.pathname)
                                ? { backgroundColor: "#D97358" }
                                : //completed
                                seoConfigComplete[0] === true
                                  ? { backgroundColor: "#42ba96" }
                                  : //not yet started
                                  { backgroundColor: "#A3A3A3" }
                      }
                      className="bar-box">
                      SEO Configuration
                    </div>
                  </Link>
                </Col>
                <Col className="p-0 mr-2">
                  <div
                    style={allComplete === true ? { backgroundColor: "#42ba96", color: "white" } : { backgroundColor: "#A3A3A3", color: "#FFFFFF" }}
                    className="bar-box">
                    Complete!
                  </div>
                </Col>
              </Row>
              {leftBar}
              {midBar}
              {rightBar}
            </div>
            <Row className="justify-content-center mt-2 ml-5">
              <Col md={4}>
                <p className="f16 primary">Onboarding Progress</p>
              </Col>
            </Row>
          </div>
        </Col>
        <Col className="hide-tablet"></Col>
      </Row>
    </Container>
  );
}
